module.exports = __webpack_public_path__ + "img/excel-icon.d8d4dc70.svg";